import React, { useRef, useEffect, memo } from 'react';
import { Message } from './';
import { cn } from '../../utils';
import type { MessageListProps } from '../../types/chat';
import './MessageList.css';

const MessageListComponent: React.FC<MessageListProps> = ({
  messages,
  isLoading,
  className = "",
  onViewAttachment,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isLoading]);

  if (messages.length === 0 && !isLoading) {
    return (
      <div className={cn('message-list', 'message-list--empty', className)}>
        <div className="message-list-empty">
          <div className="message-list-empty-icon">💬</div>
          <div className="message-list-empty-text">
            Начните разговор, отправив сообщение
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={cn('message-list', className)}>
      <div className="message-list-content">
        {messages.map((message, index) => {
          const content = [{ type: 'text' as const, text: message.content }];
          
          return (
            <div key={message.id || `${message.type}-${index}`} className="message-item">
              <Message 
                message={{
                  id: message.id,
                  type: message.type,
                  content,
                  attachments: message.attachments?.map(att => ({
                    ...att,
                    id: String(att.id),
                  })),
                }} 
                isLoading={false}
                onViewAttachment={onViewAttachment}
              />
            </div>
          );
        })}

        {isLoading && (
          <div className="message-item">
            <Message
              message={undefined}
              isLoading={true}
              onViewAttachment={onViewAttachment}
            />
          </div>
        )}
      </div>
      <div ref={messagesEndRef} />
    </div>
  );
};

export const MessageList = memo(MessageListComponent);
